import cn from "classnames";
import React from "react";
import { LoadingDots } from "web-ui";

import type { LeaderboardResponse } from "../api/languageChallenge";
import { languageChallengeApi } from "../api/languageChallenge";
import styles from "../styles/Leaderboard.module.scss";
import { staticAssertNever } from "../util/types";

import LeaderboardEntry from "./LeaderboardEntry";

export interface Props {
  className?: string;
  challengeId: string;
}

interface LoadingState {
  tag: "loading";
}
interface LoadedState {
  tag: "loaded";
  leaderboard: LeaderboardResponse;
}
type PageState = LoadingState | LoadedState;

const Leaderboard = ({ className, challengeId }: Props) => {
  const [pageState, setPageState] = React.useState<PageState>({
    tag: "loading",
  });
  React.useEffect(() => {
    (async () => {
      setPageState({
        leaderboard: await languageChallengeApi.getLeaderboard(challengeId),
        tag: "loaded",
      });
    })();
  }, [challengeId]);

  return (
    <div className={cn(className, styles.wrap)}>
      {(() => {
        switch (pageState.tag) {
          case "loading":
            return (
              <div className={styles.loading}>
                <LoadingDots manualPositioning={true} type="screen-white" />
              </div>
            );
          case "loaded":
            return (
              <>
                {pageState.leaderboard.leaderboard.map((participant, index) => (
                  <LeaderboardEntry
                    className={styles.entry}
                    key={index}
                    participant={participant}
                  />
                ))}
                {pageState.leaderboard.self && (
                  <LeaderboardEntry
                    className={styles["entry-self"]}
                    key="self"
                    participant={pageState.leaderboard.self}
                  />
                )}
                {pageState.leaderboard.counterpart && (
                  <LeaderboardEntry
                    className={styles["entry-counterpart"]}
                    key="counterpart"
                    participant={pageState.leaderboard.counterpart}
                  />
                )}
              </>
            );
          default:
            staticAssertNever(pageState);
            return null;
        }
      })()}
    </div>
  );
};
export default Leaderboard;
